import React from 'react';
// With the right tsconfig settings, we can import local files as though
// they were node modules. We would want them to be modules at least in SDK.
// import { ContextProviderNodeProps } from '@decisions/dp-components/EditorChildren/EditorChild';

/** Native HTML Select box */
export function HtmlSelectEditor({ child, path, onChange }: any) {
  return (
    <select name={child.Node.Name} onChange={e => onChange(e.target.value, path)}>
      {child.EditorConfigurationValues[0].OutputValue.map((value: string) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </select>
  );
}
